import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin: 1rem;

  img {
    max-width: 9rem;
    max-height: 9rem;
  }
`

interface IProps {
  src: string
}

const Logo = ({ src }: IProps) => (
  <Wrapper>
    <img src={src} alt="event logo"/>
  </Wrapper>
)

export default Logo
